export default function ({ store, $axios, $cookies, req }, inject) {
    async function getItjInfo(itemId, options) {
        return await store.dispatch('itj/getItj', { itemId, options, $axios, $cookies });
    }
    async function getItjRecommendations(options) {
        return await store.dispatch('itj/getRecommendations', { options, $axios, $cookies });
    }

    inject('itj', { getItjInfo, getItjRecommendations });
}